<div *ngIf="checkAbilitato && abilitato" class="padd-1">
  <div *ngIf="vino && ricercaFatta && !loading">
    <div class="container-immagine">
      <img src="{{ vino.imgsrc }}" class="imgVino" alt="" />
    </div>

    <app-dettaglio-vino
      [vino]="vino"
      [codiceForm]="codiceForm"
      [linguaCorrente]="linguaCorrente"
      [vinoSelezionato]="vinoSelezionato"
      [canBack]="false"
      [stepVino]="true"
      (selezionaVino)="selezionaVino($event)"
      [idx]="vino.id"
      [fromBase]="fromBase"
      (goBack)="tornaIndietro($event)"
    ></app-dettaglio-vino>
    <div id="midbase">
      <div
        *ngIf="vinoSelezionato && vinoSelezionato.disponibile"
        id="last_step"
      >
        <app-acquisto-vino
          [vino]="vinoSelezionato"
          (refreshCart)="refreshCart()"
        ></app-acquisto-vino>
      </div>
    </div>
  </div>
  <div *ngIf="!vino && ricercaFatta && !loading" class="nores">
    <div class="nores-title">{{ "base.nessun_vino_title" | translate }}</div>
    <div
      class="nores-subtitle"
      [innerHTML]="
        'base.nessun_vino_subtitle' | translate : { value: denominazione }
      "
    ></div>
  </div>
  <div *ngIf="loading">
    <app-step1-loading></app-step1-loading>
  </div>
</div>
<div
  *ngIf="checkAbilitato && !abilitato && !abilitatoVenditaVino && !loading"
  class="padd-1"
>
  <div class="nores-text cantina-name">
    <strong>
      {{ nonabilitatoMsg | translate }}
    </strong>
  </div>
  <img src="../../assets/img/ko.png" alt="" class="w-100" />
  <div class="nores-text cantina-name">
    <strong>
      {{ nonabilitatoMsg | translate }}
    </strong>
  </div>
</div>
